import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'; 
import { en as enTranslation } from './lang/en';
import { es as esTranslation } from './lang/es';
import { zh as zhTranslation } from './lang/zh-tw';
 
void i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    es: {
      translation: esTranslation,
    },
    zh: {
      translation: zhTranslation,
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
 
export default i18n;